import { render, staticRenderFns } from "./CompanyInfo_BasicData.vue?vue&type=template&id=4135980c&scoped=true"
import script from "./CompanyInfo_BasicData.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_BasicData.vue?vue&type=script&lang=js"
import style0 from "./CompanyInfo_BasicData.vue?vue&type=style&index=0&id=4135980c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4135980c",
  null
  
)

export default component.exports